module.exports = __webpack_public_path__ + "img/couples-052.33b7eb85.jpg";